import { render } from "./Comments.vue?vue&type=template&id=3e46ebb0"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Partials/Comments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e46ebb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e46ebb0', __exports__)) {
    console.log('reload')
    api.reload('3e46ebb0', __exports__)
  }
  
  module.hot.accept("./Comments.vue?vue&type=template&id=3e46ebb0", () => {
    console.log('re-render')
    api.rerender('3e46ebb0', render)
  })

}


export default __exports__